import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { Avatar, AutoComplete } from 'antd';

import TextField from '../../global/fields/TextField';
import ImageApi from '../../../api/image';
import FeedApi from '../../../api/feed';
import lodash from 'lodash';

const SearchColleague = (props) => {
  return (
    <TextField
      fk="group"
      value={props.value}
      onFocus={props.onClick}
      label="Select colleague"
      updateFieldData={(fk, value) => props.onChange({ target: { value } })}
      triggerOnChange
      ignoreBlur
      showError={props.showError}
      validateRule="alwaysRequired"
      validateObj={{ alwaysRequired: props.value }}
    />
  );
};

const AutoCompleteOption = (props) => {
  const [state, setState] = useState({
    imageUrl: '',
  });

  useEffect(() => {
    if (props.item.image && props.item.image.thumbnailUrl) {
      ImageApi.getImage(props.item.image.thumbnailUrl).then((imageUrl) => {
        setState({ imageUrl });
      });
    }
  }, []);

  return (
    <div className="create-feed-group-option">
      <Avatar
        className="create-feed-group-option-image"
        src={state.imageUrl}
        size={36}
        shape="square"
      />
      {props.item.first_name} {props.item.last_name}
    </div>
  );
};

const CustomInput = forwardRef((props, ref) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <input
      className="antd_replacement_input"
      {...props}
      ref={ref || inputRef}
      value={props.value}
    />
  );
});

const CreateFeedItemSearchColleague = (props) => {
  const [state, setState] = useState({
    value: props.value || '',
    dataSource: [],
  });

  const input = useRef(null);

  const _searchGroupUsers = (groupId, value) => {
    FeedApi.getGroupUsers(props.selectedGroupId, value).then((result) => {
      setState({ ...state, dataSource: result.users.filter((user) => user.id) });
    });
  };

  const _debouncedSearchGroupUsers = lodash.debounce(_searchGroupUsers, 300);

  const _onChange = (newValue) => {
    setState({ ...state, value: newValue });
  };

  const _onSearch = (searchValue) => {
    if (!searchValue || !props.selectedGroupId) return setState({ ...state, dataSource: [] });

    _debouncedSearchGroupUsers(props.selectedGroupId, searchValue);
  };

  const _onSelect = (colleagueId) => {
    const selectedColleague = lodash.find(state.dataSource, { id: colleagueId });
    props.onSelect(selectedColleague);
  };

  const renderOption = (item) => {
    return (
      <AutoComplete.Option key={item.id} text={`${item.first_name} ${item.last_name}`}>
        <AutoCompleteOption item={item} />
      </AutoComplete.Option>
    );
  };

  return (
    <AutoComplete
      ref={input}
      className="create-feed-group-row"
      onChange={_onChange}
      dataSource={state.dataSource.map(renderOption)}
      onSelect={_onSelect}
      onSearch={_onSearch}
      onFocus={props.onFocus}
    >
      {/* This replaces SearchColleague component below - it is broken, replaced with CustomInput (check if any props are missing to original) */}
      <SearchColleague showError={props.showError} />
    </AutoComplete>
  );
};

export default CreateFeedItemSearchColleague;

// Please refer to CustomInput comment.
// class SearchColleague extends Component {
//   render() {
//     return (
//       <TextField
//         fk="group"
//         value={this.props.value}
//         onFocus={this.props.onFocus}
//         label="Select colleague"
//         updateFieldData={(fk, value) => this.props.onChange({ target: { value } })}
//         triggerOnChange
//         ignoreBlur
//         showError={this.props.showError}
//         validateRule="alwaysRequired"
//         validateObj={{ alwaysRequired: this.props.value }}
//       />
//     );
//   }
// }

// class AutoCompleteOption extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       imageUrl: '',
//     };
//   }

//   componentDidMount() {
//     if (this.props.item.image && this.props.item.image.thumbnailUrl) {
//       ImageApi.getImage(this.props.item.image.thumbnailUrl).then(imageUrl => {
//         this.setState({ imageUrl });
//       });
//     }
//   }

//   render() {
//     return (
//       <div className="create-feed-group-option">
//         <Avatar
//           className="create-feed-group-option-image"
//           src={this.state.imageUrl}
//           size={36}
//           shape="square"
//         />
//         {this.props.item.first_name} {this.props.item.last_name}
//       </div>
//     );
//   }
// }

// class CreateFeedItemSearchColleague extends PureComponent {
//   constructor(props) {
//     super(props);

//     this.state = {
//       value: props.value || '',
//       dataSource: [],
//     };

//     this.input = null;

//     this._debouncedSearchGroupUsers = lodash.debounce(this._searchGroupUsers, 300);
//   }

//   componentWillReceiveProps(nextProps) {
//     if (nextProps.focusSearchColleague && this.input) {
//       this.input.focus();
//       this.props.resetFocusSearchColleague();
//     }
//   }

//   _onChange = newValue => {
//     this.setState({ value: newValue });
//   };

//   _onSearch = searchValue => {
//     if (!searchValue || !this.props.selectedGroupId) return this.setState({ dataSource: [] });

//     this._debouncedSearchGroupUsers(this.props.selectedGroupId, searchValue);
//   };

//   _searchGroupUsers = (groupId, value) => {
//     FeedApi.getGroupUsers(this.props.selectedGroupId, value).then(result => {
//       this.setState({ dataSource: result.users.filter(user => user.id) });
//     });
//   };

//   _onSelect = colleagueId => {
//     const selectedColleague = lodash.find(this.state.dataSource, { id: colleagueId });
//     this.props.onSelect(selectedColleague);
//   };

//   render() {
//     return (
//       <AutoComplete
//         ref={ref => (this.input = ref)}
//         className="create-feed-group-row"
//         value={this.state.value}
//         onChange={this._onChange}
//         dataSource={this.state.dataSource.map(this.renderOption)}
//         onSelect={this._onSelect}
//         onSearch={this._onSearch}
//         onFocus={this.props.onFocus}
//       >
//         <SearchColleague showError={this.props.showError} />
//       </AutoComplete>
//     );
//   }

//   renderOption(item) {
//     return (
//       <AutoComplete.Option key={item.id} text={`${item.first_name} ${item.last_name}`}>
//         <AutoCompleteOption item={item} />
//       </AutoComplete.Option>
//     );
//   }
// }

// export default CreateFeedItemSearchColleague;
